import { BASE_BE_URL } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import {
  ALMSG_BADREQUEST_ERR,
  ALMSG_INTERNAL_ERR,
  ALMSG_UNAUTHORIZED_OP,
  BASE_ITASK_SUBURL,
  BASE_POSTURAL_EXAMINATION_DEF_SUBURL,
  BASE_POSTURAL_EXAMINATION_SUBURL,
} from "../env";
import { Patient } from "../patients/interfaces";
import {
  invalidPosturalExamination,
  PosturalExamination,
  PosturalTestDefinition,
} from "./interfaces";
export async function getAllPosturalTestsForExam(
  signedInDoctor: SignedInDoctor,
  slugStartsWith: string
): Promise<PosturalTestDefinition[]> {
  try {
    /*console.log(
      "Get all postural test definition with slug name starting with " +
        slugStartsWith,
      JSON.stringify(signedInDoctor.medicalStudioId)
    );*/
    const response = await (
      await fetch(
        BASE_BE_URL +
          BASE_POSTURAL_EXAMINATION_DEF_SUBURL.substring(
            0,
            BASE_POSTURAL_EXAMINATION_DEF_SUBURL.length - 1
          ) +
          "?exam=" +
          slugStartsWith,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + signedInDoctor.token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
    ).json();

    return response;
  } catch (error) {
    return [];
  }
}

export async function getAllPosturalExaminationForPatient(
  signedInDoctor: SignedInDoctor,
  patientId: number,
  selections?: boolean
): Promise<PosturalExamination[]> {
  try {
    /*console.log(
      "Get postural examinations for " + patientId,
      JSON.stringify(signedInDoctor.medicalStudioId)
    );*/
    const response = await fetch(
      BASE_BE_URL +
        BASE_POSTURAL_EXAMINATION_SUBURL +
        patientId +
        (selections ? "?selections=1" : ""),
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status != 200) {
      console.log((await response.json()).message);
      return [];
    } else return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function getPosturalExaminationData(
  signedInDoctor: SignedInDoctor,
  patientId: number,
  examId: number,
  selections: boolean
): Promise<PosturalExamination> {
  try {
    /*console.log(
      "Get postural examination for " + patientId + "/" + examId,
      JSON.stringify(signedInDoctor.medicalStudioId)
    );*/
    const response = await fetch(
      BASE_BE_URL +
        BASE_POSTURAL_EXAMINATION_SUBURL +
        patientId +
        "/" +
        examId +
        (selections ? "?selections=1" : ""),
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status != 200) {
      console.log((await response.json()).message);
      return invalidPosturalExamination;
    } else return await response.json();
  } catch (error) {
    console.log(error);
    return invalidPosturalExamination;
  }
}

export async function deletePosturalExaminationData(
  signedInDoctor: SignedInDoctor,
  patientId: number,
  examId: number
): Promise<PosturalExamination> {
  try {
    /*console.log(
      "Delete postural examination for " + patientId + "/" + examId,
      JSON.stringify(signedInDoctor.medicalStudioId)
    );*/
    const response = await fetch(
      BASE_BE_URL + BASE_POSTURAL_EXAMINATION_SUBURL + patientId + "/" + examId,
      {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status != 200) {
      console.log((await response.json()).message);
      return invalidPosturalExamination;
    } else return await response.json();
  } catch (error) {
    console.log(error);
    return invalidPosturalExamination;
  }
}

export async function createPosturalExamination(
  signedInDoctor: SignedInDoctor,
  selPatient: Patient,
  slugTestsStartWith: string
): Promise<PosturalExamination> {
  try {
    const newPosturalExamination = {
      type: slugTestsStartWith,
      height: selPatient.height,
      weight: selPatient.weight,
      footSize: selPatient.footSize,
      strongHand: selPatient.strongHand,
    };
    const response = await fetch(
      BASE_BE_URL + BASE_POSTURAL_EXAMINATION_SUBURL + selPatient.id,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newPosturalExamination),
      }
    );

    if (response.status == 400) {
      console.log((await response.json()).message);
      return invalidPosturalExamination;
    }
    return await response.json();
  } catch (error) {
    return invalidPosturalExamination;
  }
}

export async function editPosturalExamination(
  signedInDoctor: SignedInDoctor,
  selPatient: Patient,
  updPosturalExamination: PosturalExamination
): Promise<PosturalExamination> {
  try {
    const response = await fetch(
      BASE_BE_URL +
        BASE_POSTURAL_EXAMINATION_SUBURL +
        selPatient.id +
        "/" +
        updPosturalExamination.examId,
      {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updPosturalExamination),
      }
    );

    if (response.status == 400) {
      console.log((await response.json()).message);
      return invalidPosturalExamination;
    }
    return await response.json();
  } catch (error) {
    return invalidPosturalExamination;
  }
}

export async function editPosturalTestSelection(
  signedInDoctor: SignedInDoctor,
  patientId: number,
  examId: number,
  testId: number,
  selection: number,
  note: string
): Promise<any> {
  try {
    const editTestSelection = {
      selectedValue: selection,
      note: note,
    };
    const response = await fetch(
      BASE_BE_URL +
        BASE_POSTURAL_EXAMINATION_SUBURL +
        patientId +
        "/" +
        examId +
        "/" +
        testId,
      {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editTestSelection),
      }
    );

    if (response.status == 400) {
      console.log("error: " + (await response.json()).message);
      return "error";
    }
    return await response.json();
  } catch (error) {
    return "error";
  }
}

export async function uploadPosturalExamPhoto(
  imgBlob: Blob | undefined,
  signedInDoctor: SignedInDoctor,
  patientId: number,
  examId: number,
  imageIndex: number,
  drawn?: boolean
): Promise<string> {
  if (imgBlob == undefined) return "";

  const formData = new FormData();
  const imageFile = new File([imgBlob], patientId + "_" + examId + ".png", {
    type: "image/png",
    lastModified: new Date().getTime(),
  });
  formData.append("file", imageFile);
  formData.append("pId", "" + patientId);
  formData.append(
    "forceFilename",
    patientId + "_" + examId + "_" + imageIndex + (drawn ? "d" : "") + ".png"
  );
  try {
    /*console.log(
      "Upload img " +
        imageIndex +
        " for exam " +
        examId +
        " of patient " +
        patientId
    );*/
    const response = await fetch(
      BASE_BE_URL + BASE_ITASK_SUBURL + "upload-exam-img",
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
        },
        body: formData,
      }
    );

    if (response.ok) {
      return (await response.json()).filename;
    } else if (response.status == 400) return await response.text();
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}

export async function getPosturalExamPhoto(
  signedInDoctor: SignedInDoctor,
  patientId: number,
  examId: number,
  imageIndex: number,
  drawn?: boolean
): Promise<string | undefined> {
  const imgUrl =
    patientId + "_" + examId + "_" + imageIndex + (drawn ? "d" : "") + ".png";
  const fetchUrl =
    BASE_BE_URL + BASE_ITASK_SUBURL + "see-img/" + patientId + "/" + imgUrl;
  try {
    //console.log("Retrieving postural exam image " + fetchUrl);
    const blobResponse = await (
      await fetch(fetchUrl, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "image/png",
          "Content-Type": "application/json",
        },
      })
    ).blob();

    return blobResponse.type == "image/png"
      ? URL.createObjectURL(blobResponse)
      : "";
  } catch (error) {
    console.log(error);
    return "";
  }
}

export async function getPosturalExamDefinition(
  signedInDoctor: SignedInDoctor,
  examType?: string
): Promise<PosturalTestDefinition[] | undefined> {
  const fetchUrl =
    BASE_BE_URL +
    BASE_POSTURAL_EXAMINATION_DEF_SUBURL.substring(
      0,
      BASE_POSTURAL_EXAMINATION_DEF_SUBURL.lastIndexOf("/")
    ) +
    (examType ? "?exam=" + examType : "");
  try {
    // console.log("Retrieving postural exam tests definition " + fetchUrl);
    const jsonResponse = await (
      await fetch(fetchUrl, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
    ).json();

    return jsonResponse;
  } catch (error) {
    console.log(error);
    return undefined;
  }
}

export async function getPosturalExamPDF(
  signedInDoctor: SignedInDoctor,
  patientId: number,
  examId: number
): Promise<Blob | undefined> {
  const fetchUrl =
    BASE_BE_URL + BASE_ITASK_SUBURL + "exam-pdf2/" + patientId + "/" + examId;
  try {
    //console.log("Retrieving postural exam tests definition " + fetchUrl);
    const response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + signedInDoctor.token,
        Accept: "application/pdf",
        "Content-Type": "application/json",
      },
    });
    return await response.blob();
  } catch (error) {
    console.log(error);
    return undefined;
  }
}

export async function getMultiplePosturalExamPDF(
  signedInDoctor: SignedInDoctor,
  patientId: number,
  examsIds: number[]
): Promise<Blob | undefined> {
  const fetchUrl =
    BASE_BE_URL + BASE_ITASK_SUBURL + "exam-pdf2/" + patientId;
  try {
    console.log("Retrieving postural exam tests definition " + fetchUrl + " with examsIds " + JSON.stringify(examsIds));

    const response = await fetch(fetchUrl, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + signedInDoctor.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({"exIds": examsIds}),
    });
    return await response.blob();
  } catch (error) {
    console.log(error);
    return undefined;
  }
}


export async function getComparePosturalExam(
  signedInDoctor: SignedInDoctor,
  patientId: number,
  examsIds: number[]
): Promise<Blob | undefined> {
  const fetchUrl =
    BASE_BE_URL + BASE_ITASK_SUBURL + "exam-compare/" + patientId;
  try {
    console.log("Retrieving postural exam tests definition " + fetchUrl + " with examsIds " + JSON.stringify(examsIds));

    const response = await fetch(fetchUrl, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + signedInDoctor.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({"exIds": examsIds}),
    });
    return await response.blob();
  } catch (error) {
    console.log(error);
    return undefined;
  }
}


export async function getPosturalExamData(
  signedInDoctor: SignedInDoctor,
  patientId: number,
  examId: number
): Promise<PosturalExamination | undefined> {
  const fetchUrl =
    BASE_BE_URL + BASE_POSTURAL_EXAMINATION_SUBURL + patientId + "/" + examId;
  try {
    //console.log("Retrieving postural exam data " + fetchUrl);
    const response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + signedInDoctor.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      return await response.json();
    } else {
      console.log("Error: " + response.statusText);
      return undefined;
    }
  } catch (error) {
    console.log(error);
    return undefined;
  }
}